export default "__VITE_ASSET__hWunYLv___"